module.exports = __webpack_public_path__ + "static/media/dragon.8957f871.PNG";